import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { isBrowser } from '@websolutespa/bom-core';
import { useLabel, useClickOut } from '@websolutespa/bom-mixer-hooks';
import { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLlm } from '../../../useLlm/useLlm.js';

const Disclaimer = () => {
  const label = useLabel();
  const disclaimerRef = useRef(null);
  const app = useLlm(state => state.app);
  const [active, setActive] = useState(false);
  const appDisclaimer = app === null || app === void 0 ? void 0 : app.contents.disclaimer;
  const appDisclaimerShort = app === null || app === void 0 ? void 0 : app.contents.disclaimerShort;
  const appDisclaimerFooter = app === null || app === void 0 ? void 0 : app.contents.disclaimerFooter;
  const disclaimer = appDisclaimerFooter ? appDisclaimerShort || appDisclaimer || label('llm.disclaimer') : '';
  const disclaimerLong = appDisclaimerFooter && active ? appDisclaimer || label('llm.disclaimer') : '';
  useEffect(() => {
    let buttons = [];
    if (disclaimerRef.current) {
      buttons = Array.from(disclaimerRef.current.querySelectorAll('button'));
    }
    const buttonClickHandler = event => __awaiter(void 0, void 0, void 0, function* () {
      if (event.currentTarget && disclaimer !== disclaimerLong) {
        console.log('buttonClickHandler', disclaimerLong);
        setActive(true);
      }
    });
    buttons.forEach(x => x.addEventListener('click', buttonClickHandler));
    return () => {
      buttons.forEach(x => x.removeEventListener('click', buttonClickHandler));
    };
  }, [disclaimer, disclaimerLong]);
  useClickOut(disclaimerRef, () => {
    setActive(false);
  });
  return jsx(Fragment, {
    children: disclaimer && jsxs("div", {
      className: "llm__prompt-disclaimer",
      children: [jsx("div", {
        className: "llm__prompt-disclaimer__short",
        ref: disclaimerRef,
        dangerouslySetInnerHTML: {
          __html: disclaimer
        }
      }), isBrowser && disclaimerLong && /*#__PURE__*/createPortal(jsx("div", {
        className: "llm",
        children: jsx("div", {
          className: "llm__prompt-disclaimer__long",
          dangerouslySetInnerHTML: {
            __html: disclaimerLong
          }
        })
      }), document.body)]
    })
  });
};

export { Disclaimer };
//# sourceMappingURL=disclaimer.js.map
